import script from "./workloadsSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./workloadsSummary.vue?vue&type=script&setup=true&lang=ts"

import "./workloadsSummary.vue?vue&type=style&index=0&id=6bace654&scoped=true&lang=scss"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bace654"]])

export default __exports__